import { PLATFORM_RETAIL_LARGE, PLATFORM_OVERLAY_LARGE } from "@gaming/srvg-classes-core";
import { AppView, SimpleModel, Setup, View, Size, Position, VideoView, ProgressImagePathView, TextView,
         GalleryView, ViewSetup, ChannelSwitchEvent, PlaybackErrorEvent, LocalStorageController } from '@gaming/srvg-classes-core';
import { ChunkIndicatorView, ChunkModel, CallToActionView, AllGroupTablesView, CompetitionTimelineView, PlaceholderView,
         IframeView, ProgressbarView, TextBoxView, PhaseChangeEvent } from '../../../VfModule';
import { LivescoreWidget, TickerWidget, LivetableLeagueWidget, LivetableWidget, MatrixWidget,
         TimelineWidget, RetailOddsMultiWidget, CuprosterWidget, GroupResultWidget, ChunkNameWidget,
         ResultsRetailWidget, ResolvedMarketsWidget, AreaWidget, ImageWidget, IframeWidget, MatchdaySelectorWidget,
         CallToActionWidget, TextWidget, StatisticsH2hWidget, StatisticsRankingWidget, StatisticsTeamformWidget,
         StatisticsTotalgoalsDonutsWidget, StatisticsTotalgoalsWidget } from '../../../widgets/VfWidgetLibrary';


// Main view class for the VFC Retail view.
export class RetailView extends AppView {
    protected setups: any;
    protected mainChannel: number;
    roundCycleSetups: any;
    currentSetupModel: SimpleModel<Setup>;
    selectedChunkModel: ChunkModel;
    fadeDelay: number;
    frontLayerView: View;
    backLayerView: View;
    transition: any;

    constructor(options) {
        options = options || {};
        super(options);
        this.isExpanded = true;
        this.setups = {};
        this.roundCycleSetups = {};
        this.currentSetupModel = new SimpleModel<Setup>();
        this.fadeDelay = 2000;
        this.mainChannel = options.mainChannel || 0;
        this.selectedChunkModel = app.timeline.currentChunkModel;
        if(typeof srvg.config.screen_aspect_ratio ==="string"){
            $('#retailView').addClass("aspectratio-"+srvg.config.screen_aspect_ratio.replace(/[:\., ]/,'-'));
        }
    }

    handleDomInstantiated() {
        this.frontLayerView = this.addSubView(new View({
            selector:'#frontLayerView',
            name:'frontLayerView',
            hideShowAnimationLengthInMs: 1000
        }));
        this.backLayerView = this.addSubView(new View({
            selector:'#backLayerView',
            name:'backLayerView',
            hideShowAnimationLengthInMs: 1000
        }));
        this.instantiateSetups();
        for(var i=0; i<this.frontLayerView.subViews.length; i++) {
            this.frontLayerView.subViews[i].jQuery().addClass('noTransition');
            this.frontLayerView.subViews[i].jQuery()[0].offsetHeight; // Trigger a reflow, flushing the CSS changes
            this.frontLayerView.subViews[i].jQuery().addClass('hidden');
            this.frontLayerView.subViews[i].jQuery()[0].offsetHeight; // Trigger a reflow, flushing the CSS changes
            this.frontLayerView.subViews[i].jQuery().removeClass('noTransition');
        }
        for(var i=0; i<this.backLayerView.subViews.length; i++) {
            this.backLayerView.subViews[i].jQuery().addClass('noTransition');
            this.backLayerView.subViews[i].jQuery()[0].offsetHeight; // Trigger a reflow, flushing the CSS changes
            this.backLayerView.subViews[i].jQuery().addClass('hidden');
            this.backLayerView.subViews[i].jQuery()[0].offsetHeight; // Trigger a reflow, flushing the CSS changes
            this.backLayerView.subViews[i].jQuery().removeClass('noTransition');
        }
        super.handleDomInstantiated();
    }

    // Instantiate the subview with the given selector, deriving class and default options from the selector
    protected instantiateSubView( selector: string, entry: any ): View {
        var view: View = null;
        var options = $.extend({}, entry.options);
        var platform = PLATFORM_RETAIL_LARGE;
        if(options.platform){
            platform = options.platform;
        }

        var index:number = 0;
        var res = selector.match(/([0-9]+)$/);
        if(res && res.length>1) {
            index = parseInt(res[1], 10);
        }

        var layerView = this.frontLayerView;
        if(entry.z<0) {
            layerView = this.backLayerView;
        }

        // class of the view to be created
        var viewClass = null;

        // set name of the view to work with it if necessary
        var viewName = selector.substr(1,selector.search(/\d+$/)-1);
        //console.log("%c %s", "color: green;", selector, viewName);
        // Possible names:
        /*switch (viewName){
         case 'callToActionView':     // doesn't need to switch
         case 'videoView':
         case 'eventtimelineWidget':
         case 'cuprosterWidget':
         case 'oddsWidget':
         case 'resultTickerWidget':
         case 'livescoreWidget':
         case 'matrixWidget':
         case 'resultsretailWidget':
         case 'chunknameWidget':
         case 'liveTableWidget':
         case 'livetableLeagueWidget':
         case 'lastResultsWidget':
         case 'groupResultWidget':
         case 'backgroundView':
         case 'allGroupTablesView':
         case 'groupTablesGalleryView':
         case 'boxView':
         case 'chunkIndicatorView':
         case 'competitionTimelineView':
         case 'statisticsTotalgoalsWidget':
         case 'statisticsTotalgoalsDonutsWidget':
         case 'statisticsTeamformWidget':
         case 'statisticsH2hWidget':
         case 'statisticsRankingWidget':
         case 'tickerWidget':
         case 'textBoxView':
         case 'placeholderView':
         case 'iframeView':
         case 'progressbarView':
         default:
         }*/


        var reactOnSwitchChannel = false;
        // set default value for reactOnSwitchChannel if no value is set | default: false
        if (typeof options.reactOnSwitchChannel !== "undefined"){
            reactOnSwitchChannel = options.reactOnSwitchChannel;
            // remove key, because it has no impact for the options itself,
            // but otherwise you will have problems with missing setters
            delete options.reactOnSwitchChannel;
        }

        // options for the view to be created
        var viewOptions: any = options;
        options.selector = selector;
        options.size = new Size( entry.width || 0, entry.height || 0 );

        if( selector == '#calltoactionView' ) {
            viewClass = CallToActionView;
            //viewOptions.template = app.templateEngine.template(CallToActionView);
            viewOptions.name = 'calltoactionView';
            viewOptions.clock = {
                selector: '#clockView',
                name: 'clockview',
                // has extended layout with spans etc for other layouts needed, for example collapsed view
                layout: options.clock ? options.clock.layout : null,
                hourLayout: options.clock ? options.clock.hourLayout : null
            };
            viewOptions.progressView = new ProgressImagePathView({
                selector: '#progressView',
                width: 196,
                height: 77,
                background: srvg.url.image+'retail/colored_arrow.png',
                pathwidth: 8,
                path: [
                    { x: 92, y: 5 }, { x: 167, y: 5 }, { x: 189, y: 38 }, { x: 167, y: 71 },
                    { x: 5, y: 71 }, { x: 5, y: 5 }, { x: 92, y: 5 }
                ]
            });
            viewOptions.lockView = new View( { selector: '#lockView' } );
            viewOptions.textView = new TextView( { selector: '#calltoactionTextView' } );
            viewOptions.seasonView = null;
            viewOptions.seasonNrView = null;
            viewOptions.matchdayView = null;
            viewOptions.matchdayNrView = null;
            viewOptions.selectedChunkModel = this.selectedChunkModel;
            viewOptions.chunkIndicatorView = new ChunkIndicatorView( { template: app.templateEngine.template( ChunkIndicatorView ) } );
            viewOptions.programCodeNameView = srvg.config.show_program_code ? new TextView( { selector: '#program_code_name' } ) : null;
            viewOptions.programCodeValueView = srvg.config.show_program_code ? new TextView( { selector: '#program_code_value' } ) : null;
        }

        if( /^#videoView[0-9]*$/.test(selector) ) {
            let hdChannelUrl = null;
            if(srvg.videooptions.alt_videobasename) {
                if(!srvg.featuresInstances.getStartWithHd()) {
                    hdChannelUrl = srvg.videooptions.serverurl + srvg.videooptions.videobasename;
                }else {
                    hdChannelUrl = srvg.videooptions.serverurl + srvg.videooptions.alt_videobasename;
                }
            }

            let channel:number = index;
            if(this.mainChannel!==0) {
                // Another channel than 0 is used on videoView0
                if(channel==0) {
                    channel = this.mainChannel;
                }else if(channel==this.mainChannel) {
                    channel = 0;
                }
            }

            // Setting the videoHandlers order for the videoView
            var videoHandlers = [];
            if(srvg.Player.getWorkingStreamType()=='flash') {
                videoHandlers = ['flash', 'hls', 'html5'];
            }else {
                if(srvg.featuresInstances.getFlashVideoByDefault()===false) {
                    videoHandlers = ['hls', 'flash', 'html5'];
                }
            }

            viewClass = VideoView;
            viewOptions.template = app.templateEngine.template(viewClass);

            // workaround to set the channel via option in the settings
            if(!viewOptions.channel){
                viewOptions.channel = channel;
            }else {
                channel = viewOptions.channel;
            }

            // to mute or not to mute?
            if(typeof viewOptions.muteSound==="undefined") {
                viewOptions.muteSound = null;
            }
            var muted = VideoView.shouldThisBeMuted(viewOptions.muteSound, viewOptions.channel);

            viewOptions.videoChannelModel = app.videoSourceController.getVideoChannelModel(channel);
            viewOptions.altVideoChannelModel = app.videoSourceController.getAltVideoChannelModel(channel);

            // Workaround to avoid conflict with VideoViewController
            if(options.toggleVideoChannel){
                if(srvg.Player.getWorkingStreamType()==="hls"){
                    viewOptions.videoChannelModel.videoUrl = app.videoSourceController.toggledVideoUrlPattern.replace('$channel$', channel);
                    viewOptions.videoChannelModel.videoUrl = viewOptions.videoChannelModel.videoUrl.replace('/playlist.m3u8', '');
                }
                if(srvg.Player.getWorkingStreamType()==="flash") {
                    viewOptions.videoChannelModel.videoUrl = app.videoSourceController.toggledVideoUrlPattern.replace('$channel$', channel);
                }
            }else {
                if(srvg.Player.getWorkingStreamType()==="hls"){
                    viewOptions.videoChannelModel.videoUrl = app.videoSourceController.videoUrlPattern.replace('$channel$', channel);
                    viewOptions.videoChannelModel.videoUrl = viewOptions.videoChannelModel.videoUrl.replace('/playlist.m3u8', '');
                }
                if(srvg.Player.getWorkingStreamType()==="flash") {
                    viewOptions.videoChannelModel.videoUrl = app.videoSourceController.videoUrlPattern.replace('$channel$', channel);
                }
            }

            // use Liveplayer
            if(srvg.videoplayer.type==='liveplayer') {
                viewOptions.playerOptions = {
                    hdChannel: hdChannelUrl,
                    hdswitch: null,
                    useLiveplayer: true,
                    hidePlayButton: false,
                    hideStopButton: true,
                    hide: 'display',
                    muted: srvg.featuresInstances.getDisableAudioByDefault() || srvg.videooptions.startMute,
                    vod: false,
                    loglevel: 0,
                    ui: {
                        enabled: true,
                        videoControls: false,
                        fullscreen: false,
                        controlBarHideDelay: 3
                    },
                    poster: srvg.url.image+'video/poster.png',
                    noButton: false,
                    autoplay: true,
                    swf: srvg.url.webroot+'liveplayer/srplayer.swf',
                    videoHandlers: videoHandlers,
                    smoothTransition: false
                };
            }

            // use the Flowplayer 7
            if(srvg.videoplayer.type==='flowplayer') {
                viewOptions.playerOptions = {
                    useLiveplayer: false,
                    engine:  'html5',  // select html5 or flash
                    debug: false,   // remove this when in production
                    autoplay: false,
                    disabled: true,  // disable gui elements, player.js hides
                    volume: 1.0,
                    poster: srvg.url.image + 'video/poster.png',   // put this in css file to speed up loading
                    muted: srvg.featuresInstances.getDisableAudioByDefault() || srvg.videooptions.startMute,
                    fullscreen: srvg.featuresInstances.getDisableFullscreen() ? false : true,
                    bgcolor: '#000',
                    clip: {
                        sources: [
                            {
                                // muss zu viewOptions.videoChannelModel.videoUrl passen, sonst player error
                                type: srvg.Player.getWorkingStreamType() === "flash" ? "video/flv" : "application/x-mpegURL",
                                src: viewOptions.videoChannelModel.videoUrl
                            },
                        ],
                        live: true,
                    }
                };
            }
            viewOptions.playerOptions = {
                gui: false,
                micro: false,
            };
        }


        if( /^#eventtimelineWidget[0-9]*$/.test(selector) ) {
            let channel = index;
            viewClass = TimelineWidget;
            viewOptions.template = app.templateEngine.template('EventtimelineWidget');
            viewOptions.channel = channel;
            viewOptions.platform = platform;
        }
        if( /^#cuprosterWidget[0-9]*$/.test(selector) ) {
            viewClass = CuprosterWidget;
            viewOptions.template = app.templateEngine.template(viewClass);
            viewOptions.platform = platform;
            viewOptions.showTeamAbbr = typeof options.showTeamAbbr === 'undefined' ? true : options.showTeamAbbr; // VFC/VFLM Widget default is false
            viewOptions.show3rdPlace = typeof options.show3rdPlace === 'undefined' ? true : options.show3rdPlace; // VFC Widget default is true VFLM is false
        }
        if( /^#oddsWidget[0-9]*$/.test(selector) ) {
            viewClass = RetailOddsMultiWidget;
            viewOptions.template = app.templateEngine.template(View);
            viewOptions.platform = platform;
        }
        if( selector == '#resultTickerWidget' ) {
            viewClass = View;
            viewOptions.template = app.templateEngine.template(View);
            viewOptions.platform = platform;
        }
        if( /^#livescoreWidget[0-9]*$/.test(selector) ) {
            viewClass = LivescoreWidget;
            viewOptions.template = app.templateEngine.template(viewClass);
            viewOptions.platform =          typeof options.platform          === 'undefined' ? PLATFORM_OVERLAY_LARGE : options.platform; // Widget has no default
            viewOptions.showAbbreviations = typeof options.showAbbreviations === 'undefined' ? true : options.showAbbreviations; // VFC Widget default is true VFLM is false
            reactOnSwitchChannel = true; // to listen to the live score widget for channel switch
        }
        if( /^#matrixWidget[0-9]*$/.test(selector) ) {
            viewClass = MatrixWidget;
            viewOptions.template = app.templateEngine.template(View);
            viewOptions.platform = platform;
        }
        if( /^#resultsretailWidget[0-9]*$/.test(selector) ) {
            viewClass = ResultsRetailWidget;
            viewOptions.template = app.templateEngine.template(View);
            viewOptions.platform = platform;
        }
        if( /^#chunknameWidget[0-9]*$/.test(selector) ) {
            viewClass = ChunkNameWidget;
            viewOptions.template = app.templateEngine.template(View);
            viewOptions.platform = platform;
        }
        if( /^#liveTableWidget[0-9]*$/.test(selector) ) {
            viewClass = LivetableWidget;
            viewOptions.template = app.templateEngine.template(viewClass);
            viewOptions.platform = platform;
            if(typeof viewOptions.played === "undefined"){
                viewOptions.played = false;
            }
            viewOptions.diff                  = typeof options.diff  === 'undefined'                 ? false : options.diff; // VFC/VFLM Widget default is true
            viewOptions.showTeamAbbr          = typeof options.showTeamAbbr === 'undefined'          ? true  : options.showTeamAbbr; // VFC/VFLM Widget default is false
            viewOptions.showActiveGroupBorder = typeof options.showActiveGroupBorder === 'undefined' ? false : options.showActiveGroupBorder; // VFC/VFLM Widget default is true
        }
        if( /^#livetableLeagueWidget[0-9]*$/.test(selector) ) {
            viewClass = LivetableLeagueWidget;
            viewOptions.template = app.templateEngine.template(viewClass);
            viewOptions.platform = platform;
            viewOptions.diff         = typeof options.diff === 'undefined'         ? false : options.diff; // VFLM Widget default is true
            viewOptions.showTeamAbbr = typeof options.showTeamAbbr === 'undefined' ? true  : options.showTeamAbbr; // VFLM Widget default is false
        }
        if( selector == '#lastResultsWidget' ) {
            viewClass = View;
            viewOptions.template = app.templateEngine.template(viewClass);
            viewOptions.platform = platform;
        }
        if( /^#groupResultWidget[0-9]*$/.test(selector) ) {
            viewClass = GroupResultWidget;
            viewOptions.template = app.templateEngine.template(viewClass);
            viewOptions.platform = platform;
        }
        if( selector == '#backgroundView' ) {
            viewClass = View;
            viewOptions.template = app.templateEngine.template('BackgroundView');
        }
        if( selector == '#allGroupTablesView' ) {
            viewClass = AllGroupTablesView;
            viewOptions.template = app.templateEngine.template('AllGroupTablesView');
        }
        if( selector == '#groupTablesGalleryView' ) {
            viewClass = GalleryView;
            viewOptions.template = app.templateEngine.template('GroupTablesGalleryView')
        }
        if( /^#boxView[0-9]*$/.test(selector) ) {
            viewClass = View;
            viewOptions.template = app.templateEngine.template('BoxView')
        }
        if( selector == '#chunkIndicatorView' ) {
            viewClass = ChunkIndicatorView;
            viewOptions.template = app.templateEngine.template(viewClass);
        }
        if( selector == '#competitionTimelineView' ) {
            viewClass = CompetitionTimelineView;
            viewOptions.template = app.templateEngine.template(viewClass);
        }
        if( /^#statisticsTotalgoalsWidget[0-9]*$/.test(selector) ) {
            viewClass = StatisticsTotalgoalsWidget;
            viewOptions.template = app.templateEngine.template(viewClass);
            viewOptions.platform = platform;

            viewOptions.showHeader = typeof options.showHeader === 'undefined' ? true : options.showHeader; // VFC/VFLM Widget default is false
        }
        if( /^#statisticsTotalgoalsDonutsWidget[0-9]*$/.test(selector) ) {
            viewClass = StatisticsTotalgoalsDonutsWidget;
            viewOptions.template = app.templateEngine.template(viewClass);
            viewOptions.platform = platform;

            viewOptions.showHeader = typeof options.showHeader === 'undefined' ? true : options.showHeader; // VFC/VFLM Widget default is false
        }
        if( /^#statisticsTeamformWidget[0-9]*$/.test(selector) ) {
            viewClass = StatisticsTeamformWidget;
            viewOptions.template = app.templateEngine.template(viewClass);
            viewOptions.platform = platform;

            viewOptions.showHeader = typeof options.showHeader === 'undefined' ? true : options.showHeader; // VFC/VFLM Widget default is false
        }
        if( /^#statisticsH2hWidget[0-9]*$/.test(selector) ) {
            viewClass = StatisticsH2hWidget;
            viewOptions.template = app.templateEngine.template(viewClass);
            viewOptions.platform = platform;

            viewOptions.showHeader = typeof options.showHeader === 'undefined' ? true : options.showHeader; // VFC/VFLM Widget default is false
        }
        if( /^#statisticsRankingWidget[0-9]*$/.test(selector) ) {
            viewClass = StatisticsRankingWidget;
            viewOptions.template = app.templateEngine.template(viewClass);
            viewOptions.platform = platform;

            viewOptions.showHeader = typeof options.showHeader === 'undefined' ? true : options.showHeader; // VFC/VFLM Widget default is false
        }
        if(/^#tickerWidget[0-9]*$/.test(selector)){
            viewClass = TickerWidget;
            viewOptions.template = app.templateEngine.template(viewClass);
            viewOptions.platform = platform;
        }
        if(/^#textWidget[0-9]*$/.test(selector)){
            viewClass = TextWidget;
            viewOptions.template = app.templateEngine.template(viewClass);
            viewOptions.platform = platform;
        }
        if(/^#areaWidget[0-9]*$/.test(selector)){
            viewClass = AreaWidget;
            viewOptions.template = app.templateEngine.template(viewClass);
            viewOptions.platform = platform;
        }
        if(/^#imageWidget[0-9]*$/.test(selector)){
            viewClass = ImageWidget;
            viewOptions.template = app.templateEngine.template(viewClass);
            viewOptions.platform = platform;
        }
        if(/^#iframeWidget[0-9]*$/.test(selector)){
            viewClass = IframeWidget;
            viewOptions.template = app.templateEngine.template(viewClass);
            viewOptions.platform = platform;
        }
        if(/^#matchdaySelectorWidget[0-9]*$/.test(selector)){
            viewClass = MatchdaySelectorWidget;
            viewOptions.template = app.templateEngine.template(viewClass);
            viewOptions.platform = platform;
        }
        if(/^#callToActionWidget[0-9]*$/.test(selector)){
            viewClass = CallToActionWidget;
            viewOptions.template = app.templateEngine.template(viewClass);
            viewOptions.platform = platform;
        }
        if(/^#textBoxView[0-9]*$/.test(selector)){
            viewClass = TextBoxView;
            viewOptions.template = app.templateEngine.template(viewClass);
        }
        if(/^#placeholderView[0-9]*$/.test(selector)){
            viewClass = PlaceholderView;
            viewOptions.template = app.templateEngine.template(viewClass);
        }
        if(/^#iframeView[0-9]*$/.test(selector)){
            viewClass = IframeView;
            viewOptions.template = app.templateEngine.template(viewClass);
        }
        if("#progressbarView" === selector){
            viewClass = ProgressbarView;
            viewOptions.template = app.templateEngine.template(viewClass);
        }

        if( /^#resolvedMarketsWidget[0-9]*$/.test(selector) ) {
            viewClass = ResolvedMarketsWidget;
            viewOptions.template = app.templateEngine.template(viewClass);
            viewOptions.platform = platform;
        }

        // set same widgetGroup if widget should react on channel switch
        if (reactOnSwitchChannel && !viewOptions.widgetGroup){
            viewOptions.widgetGroup = 'channelSwitch';
        }
        delete viewOptions.reactOnSwitchChannel;

        // create the view
        if(viewClass) {
            view = new viewClass(viewOptions, srvg);
        }

        // subscribe to channel switch event if view should react on channel switch
        if (reactOnSwitchChannel){
            srvg.eventExchange.addEventHandler(view, 'all', ChannelSwitchEvent);
        }


        if(/^#videoView[0-9]*$/.test(selector)) {
            // configure view for Local Storage
            if(app.videoSourceController instanceof LocalStorageController) {
                // set looping to true
                let videoView:VideoView = <VideoView>view;
                videoView.setLooping( true );
                videoView.addSubscriberForEvent( app.videoSourceController, PlaybackErrorEvent );
            }
        }
        if(/^#iframeView[0-9]*$/.test(selector)){
            app.timelineController.addSubscriberForEvent(view, PhaseChangeEvent);
        }

        // Fallback
        if(!view) {
            console.warn(selector+' could not be identified, creating vanilla view');
            if(!$(selector).get(0) ) {
                let id = selector.substr(1);
                $('<div id="'+id+'" style="width:100px; height:100px;"></div>').appendTo(this.$domNode);
            }
            view = new View({selector: selector});
        }

        // add view to the layer as subview and return it
        layerView.addSubView(view);
        return view;
    }

    // Instantiate all viewSetups in this setup
    protected instantiateSetup(setupName, entries) {

        // Create setup object
        var setup = new Setup(setupName);
        this.setups[setupName] = setup;

        // Create view setup objects for all entries in this setup
        for(var viewName in entries) {
            var entry = entries[viewName];
            var selector = viewName;
            var view = this.findSubViewBySelector(selector, true);
            if(!view) {
                view = this.instantiateSubView(selector, entry)
            }
            var isShown = !entry.disabled;
            var zoom = entry.zoom ? entry.zoom : 1;
            var zoomOrigin = entry.zoom_origin || 'top left';
            var position = new Position( entry.x || 0, entry.y || 0, entry.z || 0 );
            var size = new Size( entry.width || 0, entry.height || 0 );
            var cssClasses = entry.css_classes || '';
            var options = entry.options || {};
            var animated = entry.animated || false;
            setup.viewSetups.push(new ViewSetup(
                setup,
                view,
                isShown,
                position,
                size,
                zoom,
                zoomOrigin,
                cssClasses,
                options,
                animated)
            );
        }

    }

    // Interpret the setup configuration and instantiate the screen setups.
    instantiateSetups() {
        var screen_timings = srvg.config.screen_timings;
        var setupData = srvg.config.screen_setups;
        var that = this;
        for(var round in screen_timings) {
            this.roundCycleSetups[round] = {};
            var roundParts = Object.getOwnPropertyNames(screen_timings[round]);
            roundParts.forEach(function(roundPart) {
                that.roundCycleSetups[round][roundPart] = [];
                if (roundPart != "length"){ // pitfall arrays returns also length. In IE you can not fetch getOwnPropertyNames from roundPart:length
                    var cycles = Object.getOwnPropertyNames(screen_timings[round][roundPart]);
                    cycles.forEach(function(cycle) {
                        that.roundCycleSetups[round][roundPart][cycle] = [];
                        $.each(screen_timings[round][roundPart][cycle], function(index, timing) {
                            var setupForThisRoundAndCycle = timing.setup_name;

                            // Not instantiated yet?
                            if(!that.setups[setupForThisRoundAndCycle]) {
                                if( setupData[setupForThisRoundAndCycle] ) {
                                    that.instantiateSetup(
                                        setupForThisRoundAndCycle,
                                        setupData[setupForThisRoundAndCycle]
                                    );
                                }
                            }

                            if(that.setups[setupForThisRoundAndCycle]) {

                                // Store view for this setup
                                that.roundCycleSetups[round][roundPart][cycle].push({
                                    setup: that.setups[setupForThisRoundAndCycle],
                                    display_length: timing.display_length,
                                    min_display_length: timing.min_display_length || null
                                });
                            }else {
                                console.error('Setup "'+setupForThisRoundAndCycle+'" not found');
                            }

                        });
                    });
                }
            });
        }
    }

    // Display the screen setup with the given name
    setCurrentSetupByName( newSetupName: string ): void {
        if( this.setups[newSetupName] ) {
            this.setCurrentSetup( this.setups[newSetupName], false );
        }
        else {
            console.error( 'Unknown setup', newSetupName );
        }
    }

    // Display new views of new screen setup and hide unused views of current setup
    setCurrentSetup(newSetup:Setup, animated:boolean) {
        var oldSetup = this.currentSetupModel.get();
        if(oldSetup===newSetup) {
            return;
        }
        var viewsToBeAdded = [];
        if(oldSetup) {
            let oldViews = oldSetup.viewSetups;
            let newViews = newSetup.viewSetups;
            let viewsToBeRemoved = [];
            let viewsToBeChanged = [];

            // which views are to be removed or only changed ?
            for(var iOld in oldViews) {
                var isFound = '';
                for(var iNew in newViews) {
                    if(oldViews[iOld].view.objectId==newViews[iNew].view.objectId) {
                        // console.log('--- --- %cview should stay:', 'color:#41a62a', oldViews[iOld].view.name);
                        isFound = iOld;
                        viewsToBeChanged.push([oldViews[iOld],newViews[iNew]]);
                        break;
                    }
                }
                if(isFound=='') {
                    viewsToBeRemoved.push(oldViews[iOld]);
                    // console.log('--- --- %cview should leave:', 'color:#d33131', oldViews[iOld].view.name);
                }
            }

            // which views are to be added ?
            for(let iNew in newViews) {
                let isFound = '';
                for(let iOld in oldViews) {
                    if(newViews[iNew].view.objectId==oldViews[iOld].view.objectId) {
                        // console.log('--- --- %cview is alreday there:', 'color:#d7a438', oldViews[iOld].view.name);
                        isFound = iNew;
                        break;
                    }
                }
                if(isFound=='') {
                    viewsToBeAdded.push(newViews[iNew]);
                    // console.log('--- --- %cview should arrive:', 'color:#3870d7', newViews[iNew].view.name);
                }
            }

            // TODO: we replaced the one transitionend by a timeout to avoid issues - is that really needed ?
            // hide views that are to be removed
            for(let i in viewsToBeRemoved) {
                let viewToBeRemoved = viewsToBeRemoved[i];
                window.setTimeout(function() {
                    viewToBeRemoved.view.jQuery().removeClass(viewToBeRemoved.cssClasses);

                    // stop video
                    if(viewToBeRemoved.view.name==='videoView' && viewToBeRemoved.view.player && viewToBeRemoved.view.player.api && typeof viewToBeRemoved.view.player.api.stop=='function') {
                        viewToBeRemoved.view.player.api.stop();
                    }
                }, 1200);
                /*
                viewToBeRemoved.view.jQuery().one('transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd', viewToBeRemoved, function(e) {
                    let viewToBeRemoved = e.data;
                    viewToBeRemoved.view.jQuery().removeClass(viewToBeRemoved.cssClasses);

                    // stop video
                    if(viewToBeRemoved.view.name==='videoView' && viewToBeRemoved.view.player && viewToBeRemoved.view.player.api && typeof viewToBeRemoved.view.player.api.stop=='function') {
                        
                        console.log('# stop #');

                        viewToBeRemoved.view.player.api.stop();
                    }

                });
                */

                // transition out
                viewToBeRemoved.view.jQuery().addClass('hidden');
            }

            // change views that are to be changed
            for(let i in viewsToBeChanged) {
                let viewToBeChanged = viewsToBeChanged[i][0];
                let viewToBeChangedTo = viewsToBeChanged[i][1];
                if(
                    JSON.stringify(viewToBeChanged.viewOptions)!=JSON.stringify(viewToBeChangedTo.viewOptions)
                    || JSON.stringify(viewToBeChanged.size)!=JSON.stringify(viewToBeChangedTo.size)
                    || JSON.stringify(viewToBeChanged.position)!=JSON.stringify(viewToBeChangedTo.position)
                    || viewToBeChanged.cssClasses != viewToBeChangedTo.cssClasses
                ) {
                    // console.log('--- --- --- %cview gets changed:', 'color:#d538d7', viewToBeChanged.view.name);

                    // copy and overlay view to do transition-out with copy while transition-in with changed origin
                    let cloned = viewToBeChanged.view.jQuery().clone();
                    cloned.appendTo('#frontLayerView');

                    // there could be a canvas inside which context would not be cloned. clone it by hand.
                    let canvas = viewToBeChanged.view.jQuery().find('canvas');
                    let clonedCanvas = cloned.find('canvas');
                    $.each(canvas, function(index, value) {
                        if(canvas.width() && canvas.width()>0 && canvas.height() && canvas.height()>0) {
                            let context = canvas[index].getContext('2d');
                            let imageData = context.getImageData(0, 0, canvas.width(), canvas.height());
                            let clonedContext = clonedCanvas[index].getContext('2d');
                            clonedContext.putImageData(imageData, 0, 0);
                        }
                    });

                    // transition out
                    cloned.one('transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd', function(e) {
                        e.target.remove();
                    });

                    cloned[0].offsetHeight; // Trigger a reflow, flushing the CSS changes
                    cloned.addClass('hidden'); // transition out
                    cloned[0].offsetHeight; // Trigger a reflow, flushing the CSS changes
                    cloned.addClass('hidden');
                    cloned[0].offsetHeight; // Trigger a reflow, flushing the CSS changes

                    // set hidden without transition
                    viewToBeChanged.view.jQuery().addClass('noTransition');
                    viewToBeChanged.view.jQuery()[0].offsetHeight; // Trigger a reflow, flushing the CSS changes
                    viewToBeChanged.view.jQuery().addClass('hidden');
                    viewToBeChanged.view.jQuery()[0].offsetHeight; // Trigger a reflow, flushing the CSS changes
                    viewToBeChanged.view.jQuery().removeClass(viewToBeChanged.cssClasses);
                    viewToBeChanged.view.jQuery().addClass(viewToBeChangedTo.cssClasses);
                    viewToBeChanged.view.jQuery()[0].offsetHeight; // Trigger a reflow, flushing the CSS changes
                    delete viewToBeChanged.viewOptions.reactOnSwitchChannel;
                    viewToBeChanged.view.setOptions(viewToBeChangedTo.viewOptions);
                    viewToBeChanged.view.setDimensions(
                        viewToBeChangedTo.position,
                        viewToBeChangedTo.size,
                        viewToBeChangedTo.zoom,
                        viewToBeChangedTo.zoomOrigin
                    );
                    viewToBeChanged.view.jQuery()[0].offsetHeight; // Trigger a reflow, flushing the CSS changes
                    viewToBeChanged.view.jQuery().removeClass('noTransition');
                    viewToBeChanged.view.jQuery()[0].offsetHeight; // Trigger a reflow, flushing the CSS changes

                    // transition in
                    viewToBeChanged.view.jQuery().removeClass('hidden');

                }else {
                    // console.log('--- --- --- %cview does not need to be changed', 'color:#2abfb3', viewToBeChanged.view.name);
                }
            }

        }else {
            viewsToBeAdded = newSetup.viewSetups;
        }
        this.currentSetupModel.set(newSetup);
        if(this.currentSetupModel.get()) {

            // show views that are to be added
            $('body').attr('data-screen', this.currentSetupModel.get().name);
            $('#setup_name').html(this.currentSetupModel.get().name);
            for(let i in viewsToBeAdded) {
                let viewToBeAdded = viewsToBeAdded[i];

                // start video
                if(viewToBeAdded.view.name==='videoView' && viewToBeAdded.view.player && viewToBeAdded.view.player.api && typeof viewToBeAdded.view.player.api.play=='function') {
                    viewToBeAdded.view.player.api.play();
                }

                viewToBeAdded.view.jQuery().addClass(viewToBeAdded.cssClasses);
                delete viewToBeAdded.viewOptions.reactOnSwitchChannel;
                viewToBeAdded.view.setOptions(viewToBeAdded.viewOptions);
                viewToBeAdded.view.setDimensions(
                    viewToBeAdded.position,
                    viewToBeAdded.size,
                    viewToBeAdded.zoom,
                    viewToBeAdded.zoomOrigin
                );
                viewToBeAdded.view.jQuery()[0].offsetHeight; // Trigger a reflow, flushing the CSS changes

                // transition in
                viewToBeAdded.view.jQuery().removeClass('hidden');

            }

        }
    }

}